"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
export default function GlobalError(t0) {
  const $ = _c(7);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error, {
        extra: error.message as any || ""
      });
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="text-2xl font-bold text-red-500 mb-4">Something went wrong!</h2>;
    t4 = <p className="text-gray-700 mb-6">We're sorry, an unexpected error occurred. Please try again later.</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== reset) {
    t5 = <html><body className="flex items-center justify-center min-h-screen bg-gray-100"><div className="text-center bg-white p-8 rounded-lg shadow-xl max-w-md w-full">{t3}{t4}<button onClick={() => reset()} className="bg-blue-500 text-white px-6 py-2 rounded-full hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400">Try again</button></div></body></html>;
    $[5] = reset;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}